import client from '../../../vendor/rshop/frontend/assets/js/common/client'

const lang = document.querySelector('html').getAttribute('lang')
let locale = {}

const localePromise = import(`../locale/${lang}`).then((module) => {
    locale = module
})

// ─── HTML escape helper ───────────────────────────────────────────────────────

const esc = (str) => {
    if (!str) {
        return ''
    }
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
}

// ─── Company fields toggle ────────────────────────────────────────────────────

const toggleCompanyFields = () => {
    const cb = document.getElementById('client-is-company')
    const fields = document.querySelector('.js-company-fields')
    if (!cb || !fields) {
        return
    }

    fields.style.display = cb.checked ? '' : 'none'

    ;['company_name', 'org_num', 'company_street', 'company_city', 'company_zip'].forEach((name) => {
        const input = fields.querySelector(`[name="${name}"]`)
        if (!input) {
            return
        }

        input.required = cb.checked

        const item = input.closest('.c-form__item')
        if (item) {
            item.classList.toggle('is-required', cb.checked)
        }

        if (!cb.checked) {
            input.classList.remove('error', 'valid')
            input.removeAttribute('aria-invalid')

            const validator = $(input.form).data('validator')
            if (validator) {
                validator.errorsFor(input).remove()
            }
        }
    })
}

const initCompanyToggle = () => {
    const cb = document.getElementById('client-is-company')
    if (cb && !cb.dataset.toggleBound) {
        cb.addEventListener('change', toggleCompanyFields)
        cb.dataset.toggleBound = '1'
    }
}

const resetClientFormValidation = (form) => {
    const validator = $(form).data('validator')
    if (validator) {
        validator.resetForm()
    }
}

// ─── Open "add client" modal ──────────────────────────────────────────────────

const openAddClientModal = async () => {
    const form = document.querySelector('.js-client-form')
    if (!form) {
        return
    }

    await localePromise

    const translations = locale.PriceOffer.Clients

    form.reset()
    resetClientFormValidation(form)
    form.setAttribute('action', '/klienti/vytvorit')

    const clientId = document.getElementById('client-id')
    if (clientId) {
        clientId.value = ''
    }

    const title = document.querySelector('#client-modal .c-modal__name')
    if (title) {
        title.textContent = translations.addTitle
    }

    const submitLabel = document.querySelector('#client-modal .js-client-submit-label')
    if (submitLabel) {
        submitLabel.textContent = translations.addSubmit
    }

    initCompanyToggle()
    toggleCompanyFields()
    $('#client-modal').modal('show')
}

// Click on any "add client" button (index page and detail page)
document.addEventListener('click', (event) => {
    const btn = event.target.closest('.js-add-client-btn')
    if (!btn) {
        return
    }

    const listModal = document.getElementById('clients-list-modal')

    if (listModal && listModal.classList.contains('in')) {
        // Close clients-list first, then open add form
        $('#clients-list-modal').one('hidden.bs.modal', openAddClientModal).modal('hide')
    } else {
        openAddClientModal()
    }
})

// ─── Edit client ──────────────────────────────────────────────────────────────

document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.js-edit-client')
    if (!btn) {
        return
    }

    await localePromise

    const clientId = btn.dataset.clientId

    client
        .get(`/klienti/detail/${clientId}`)
        .then((response) => {
            if (!response.data.status) {
                Eshop.alert(response.data.message || locale.GeneralError, { type: 'error' })
                return
            }

            const data = response.data.client
            const form = document.querySelector('.js-client-form')
            if (!form) {
                return
            }

            initCompanyToggle()
            resetClientFormValidation(form)

            const clientIdField = document.getElementById('client-id')
            if (clientIdField) {
                clientIdField.value = data.id
            }

            const isCompanyCb = document.getElementById('client-is-company')
            if (isCompanyCb) {
                isCompanyCb.checked = !!data.is_company
            }

            ;[
                ['first_name', data.first_name],
                ['last_name', data.last_name],
                ['email', data.email],
                ['phone', data.phone],
                ['street', data.street || ''],
                ['city', data.city || ''],
                ['zip', data.zip || ''],
                ['apartment_floor', data.apartment_floor || ''],
                ['company_name', data.company_name || ''],
                ['org_num', data.org_num || ''],
                ['tax_num', data.tax_num || ''],
                ['vat_num', data.vat_num || ''],
                ['company_street', data.company_street || ''],
                ['company_city', data.company_city || ''],
                ['company_zip', data.company_zip || ''],
                ['company_apartment_floor', data.company_apartment_floor || ''],
            ].forEach(([name, value]) => {
                const field = form.querySelector(`[name="${name}"]`)
                if (field) {
                    field.value = value
                }
            })

            toggleCompanyFields()
            form.setAttribute('action', `/klienti/upravit/${clientId}`)

            const title = document.querySelector('#client-modal .c-modal__name')
            if (title) {
                title.textContent = locale.PriceOffer.Clients.editTitle
            }

            const submitLabel = document.querySelector('#client-modal .js-client-submit-label')
            if (submitLabel) {
                submitLabel.textContent = locale.PriceOffer.Clients.editSubmit
            }

            $('#client-modal').modal('show')
        })
        .catch(() => {
            Eshop.alert(locale.GeneralError, { type: 'error' })
        })
})

// ─── Submit client form ───────────────────────────────────────────────────────

const clientForm = document.querySelector('.js-client-form')

if (clientForm) {
    let isSubmitting = false

    const isCompany = () => {
        const checkbox = document.getElementById('client-is-company')
        return checkbox && checkbox.checked
    }

    const validator = $(clientForm).validate({
        rules: {
            company_name: { required: isCompany },
            org_num: { required: isCompany },
            company_street: { required: isCompany },
            company_city: { required: isCompany },
            company_zip: { required: isCompany }
        },
        submitHandler: async (form, event) => {
            if (event) {
                event.preventDefault()
            }

            if (isSubmitting) {
                return
            }

            isSubmitting = true

            const submitBtn = form.querySelector('[type="submit"]')
            submitBtn.disabled = true
            submitBtn.classList.add('is-loading')

            await localePromise

            const formData = new FormData(form)
            const data = Object.fromEntries(formData.entries())
            delete data.client_id

            data.is_company = isCompany() ? 1 : 0

            let succeeded = false

            client
                .post(form.getAttribute('action'), data)
                .then((response) => {
                    if (!response.data.status) {
                        const validationErrors = response.data.validation_errors || {}
                        const fieldErrors = Object.keys(validationErrors).reduce((errors, field) => {
                            const messages = validationErrors[field]
                            const message = typeof messages === 'string'
                                ? messages
                                : Object.values(messages || {})[0]

                            if (message) {
                                errors[field] = message
                            }

                            return errors
                        }, {})

                        if (Object.keys(fieldErrors).length) {
                            validator.showErrors(fieldErrors)
                            const firstInvalid = form.querySelector('.error')
                            if (firstInvalid) {
                                firstInvalid.focus()
                            }
                        } else {
                            Eshop.alert(response.data.message || locale.GeneralError, { type: 'error' })
                        }

                        return
                    }

                    succeeded = true
                    Eshop.alert(response.data.message, { type: 'success' })
                    $('#client-modal').modal('hide')
                    setTimeout(() => window.location.reload(), 500)
                })
                .catch(() => {
                    Eshop.alert(locale.GeneralError, { type: 'error' })
                })
                .then(() => {
                    if (succeeded) {
                        return
                    }

                    submitBtn.disabled = false
                    submitBtn.classList.remove('is-loading')
                    isSubmitting = false
                })
        }
    })
}

// ─── Clients list ─────────────────────────────────────────────────────────────

const renderClientsSkeleton = () => Array.from({ length: 5 }, () => `
    <div class="c-clients-modal__row" aria-hidden="true">
        <div class="c-clients-modal__identity">
            <span class="c-clients-modal__line is-name"></span>
            <span class="c-clients-modal__line is-address"></span>
        </div>
        <div class="c-clients-modal__contact">
            <span class="c-clients-modal__line is-email"></span>
            <span class="c-clients-modal__line is-phone"></span>
        </div>
        <div class="c-clients-modal__row-actions">
            <span class="c-clients-modal__skeleton-button"></span>
            <span class="c-clients-modal__skeleton-button"></span>
        </div>
    </div>
`).join('')

const renderClientRow = (c, translations) => `
    <div class="c-clients-modal__row" data-client-id="${c.id}">
        <div class="c-clients-modal__identity">
            <strong class="c-clients-modal__name">${esc(c.is_company && c.company_name ? c.company_name : c.full_name)}</strong>
            <span class="c-clients-modal__address">${esc(c.full_address)}</span>
        </div>
        <div class="c-clients-modal__contact">
            <span>${esc(c.email)}</span>
            <span>${esc(c.phone)}</span>
        </div>
        <div class="c-clients-modal__row-actions">
            <button type="button" class="c-btn c-btn--ghost c-btn--square js-edit-client"
                data-client-id="${c.id}" title="${esc(translations.editTitle)}">
                <i class="ico ico-client-pencil c-clients-modal__ico" aria-hidden="true"></i>
            </button>
            <button type="button" class="c-btn c-btn--ghost c-btn--square js-view-client-offers"
                data-client-id="${c.id}" title="${esc(translations.viewOffersTitle)}">
                <i class="ico ico-client-eye c-clients-modal__ico" aria-hidden="true"></i>
            </button>
        </div>
    </div>
`

$('#clients-list-modal').on('show.bs.modal', async () => {
    const body = document.querySelector('.js-clients-table-body')
    if (!body) {
        return
    }

    await localePromise

    const translations = locale.PriceOffer.Clients

    body.classList.add('is-skeleton')
    body.setAttribute('aria-busy', 'true')
    body.setAttribute('aria-label', translations.loading)
    body.innerHTML = renderClientsSkeleton()
    body.scrollTop = 0

    client
        .get('/klienti/zoznam')
        .then((response) => {
            body.classList.remove('is-skeleton')
            body.removeAttribute('aria-busy')
            body.removeAttribute('aria-label')

            if (!response.data.status) {
                body.innerHTML = `<div class="c-msg c-msg--error">${esc(response.data.message)}</div>`
                return
            }

            const clients = response.data.data

            if (!clients || clients.length === 0) {
                body.innerHTML = `<div class="c-msg c-msg--info is-empty">${esc(translations.empty)}</div>`
                return
            }

            body.innerHTML = clients.map((clientData) => renderClientRow(clientData, translations)).join('')
        })
        .catch(() => {
            body.classList.remove('is-skeleton')
            body.removeAttribute('aria-busy')
            body.removeAttribute('aria-label')
            body.innerHTML = `<div class="c-msg c-msg--error">${esc(translations.loadError)}</div>`
        })
})

// ─── Delete client ────────────────────────────────────────────────────────────

document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.js-delete-client')
    if (!btn) {
        return
    }

    await localePromise

    const clientId = btn.dataset.clientId

    Eshop.confirm(
        locale.Swal.DeleteClient.title,
        {
            denyButtonText: locale.Swal.DeleteClient.deny,
            confirmButtonText: locale.Swal.DeleteClient.confirm
        },
        () => {
            client
                .post(`/klienti/zmazat/${clientId}`)
                .then((response) => {
                    if (!response.data.status) {
                        Eshop.alert(response.data.message || locale.GeneralError, { type: 'error' })
                        return
                    }

                    Eshop.alert(response.data.message, { type: 'success' })

                    const row = btn.closest('[data-client-id]')
                    if (row) {
                        row.remove()
                    }

                    const tableBody = document.querySelector('.js-clients-table-body')
                    if (tableBody && !tableBody.querySelector('[data-client-id]')) {
                        tableBody.innerHTML = `<div class="c-msg c-msg--info is-empty">${esc(locale.PriceOffer.Clients.empty)}</div>`
                    }
                })
                .catch(() => {
                    Eshop.alert(locale.GeneralError, { type: 'error' })
                })
        }
    )
})

// ─── View a client's offers (eye button) ──────────────────────────────────────

document.addEventListener('click', (event) => {
    const btn = event.target.closest('.js-view-client-offers')
    if (!btn) {
        return
    }

    window.location.href = `/cenove-ponuky?f=customer%3D${btn.dataset.clientId}`
})

// ─── "Add customer info" placeholder on offer detail ──────────────────────────
// Opens the "select customer" dropdown that already lives in the detail header.

document.addEventListener('click', (event) => {
    const placeholder = event.target.closest('.js-select-client-placeholder')
    if (!placeholder) {
        return
    }

    const select = document.querySelector('.js-price-offer-client-select')
    if (!select) {
        return
    }

    select.focus()

    if (typeof select.showPicker === 'function') {
        try {
            select.showPicker()
        } catch (error) {
            // showPicker throws outside a user gesture / when unsupported, focus already applied
        }
    }
})

// ─── Client select on offer detail ───────────────────────────────────────────

const clientSelect = document.querySelector('.js-price-offer-client-select')

if (clientSelect) {
    clientSelect.dataset.originalValue = clientSelect.value

    clientSelect.addEventListener('change', async (event) => {
        await localePromise

        const offerId = event.target.dataset.offerId
        const clientId = parseInt(event.target.value, 10) || null
        const originalValue = event.target.dataset.originalValue

        event.target.disabled = true

        client
            .post(`/klienti/priradit/${offerId}`, { client_id: clientId })
            .then((response) => {
                if (!response.data.status) {
                    Eshop.alert(response.data.message || locale.GeneralError, { type: 'error' })
                    event.target.value = originalValue
                    return
                }

                event.target.dataset.originalValue = clientId || ''
                Eshop.alert(response.data.message, { type: 'success' })
                setTimeout(() => window.location.reload(), 1000)
            })
            .catch(() => {
                Eshop.alert(locale.GeneralError, { type: 'error' })
                event.target.value = originalValue
            })
            .then(() => {
                event.target.disabled = false
            })
    })
}
